import React from 'react';

/**
 * A live counter in a summary stats row (Compatibility, Loudness, Organize)
 * that never nudges its neighbours as it climbs.
 *
 * The number sits in a slot exactly as wide as the widest value it can reach
 * — an invisible ghost ("000" for a 3-digit run, see utils/statDigits.js)
 * rendered under it in the same grid cell, in the real font with tabular
 * figures — so "1" → "22" → "150" grows into reserved space and the label
 * beside it and every item after it keep their place. `align="end"` (default)
 * right-aligns the value for number-then-label items; `align="start"` for
 * "Label: N" items, where the spare width merges with the item margin.
 *
 * `ghost` overrides the reservation for non-integer values ("-00.0 LUFS").
 */
export default function StatCount({ value, digits = 1, ghost, align = 'end', className = '', ...rest }) {
    const reserve = ghost ?? '0'.repeat(Math.max(1, digits));
    return (
        <span className={`stat-count${align === 'start' ? ' stat-count-start' : ''}${className ? ` ${className}` : ''}`} {...rest}>
            <span className="stat-count-ghost" aria-hidden="true">{reserve}</span>
            <span className="stat-count-value">{value}</span>
        </span>
    );
}
